<template>
  <div class="dx-fieldset-header pb-1 d-flex justify-content-between align-self-start w-100 position-relative">
    {{ text }}
    <dx-button
      v-if="button"
      class="custom-btn fieldset-btn"
      type="success"
      styling-mode="contained"
      :disabled="disabled"
      @click="$emit('select')"
    >
      {{ button }}
    </dx-button>
  </div>
</template>

<script>
import { DxButton } from 'devextreme-vue';

export default {
  name: 'DxFieldsetHeader',
  components: {
    DxButton,
  },
  props: {
    text: String,
    button: String,
    disabled: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.border-bottom {
  border-color: #e0e0e0;
}
</style>

<style>
.fieldset-btn {
  margin-left: auto;
  text-transform: uppercase;
  position: absolute !important;
  right: 0;
  bottom: 6px;
}
</style>
